
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMosfetPtype1On as ObiMosfetPtype1OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-mosfet-ptype-1-on.js';
 
 
 

 
 export const ObiMosfetPtype1On = createComponent({
   react: React,
   tagName: 'obi-mosfet-ptype-1-on',
   elementClass: ObiMosfetPtype1OnElement,
   events: {
     
   }
  });
 
 